import script from "./RenderModule.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderModule.vue?vue&type=script&setup=true&lang=js"

import "./RenderModule.vue?vue&type=style&index=0&id=1edc78de&lang=scss"

const __exports__ = script;

export default __exports__